module.exports = __webpack_public_path__ + "media/images/icon__dhi--rb-gray-ee9110ab2ec21f5abeb23897d5b20993.png";